// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { useStore } from '@/store';

// models
import { CourseSchema } from '@/vue3/api/models';

export const usePublicInfoService = () => {
    // hooks
    const store = useStore();

    const axios = useAxios();
    const { apiUrl } = store.state;

    const pathSegments = window.location.pathname.split('/');
    const uid = pathSegments.pop() || pathSegments.shift();
    
    // methods
    const createPublicLink = async (courseId: number) => {
        try {
            const response = await axios.post(
                `${apiUrl}/course/share-link/${courseId}`,
                {}
            );
            return store.state.frontendBaseURL+"/public/course/"+response.data;
        } catch (error) {

        }
    }

    const getPublicCourseSchema = async (): Promise<CourseSchema> => {
            const res = await axios.get(
                `${apiUrl}/public/course-schema/${uid}/list`, 
                0, 
                {"bypassAuthCheck":true}
            );
            return res.data;
    };

    const getPublicCourseExtent = async () => {
        try {
            const response = await axios.get(
                `${apiUrl}/public/course/${uid}/extent`, 
                0, 
                {"bypassAuthCheck":true} 
            );
            return response.data;
        } catch (error) {
            console.error("Invalid");
            return null;
        }
    }

    const getPublicAllGeoRecordsAsTree = async (): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/public/geo-record/tree/temp/course-schema/${uid}`,
            0, 
                {"bypassAuthCheck":true} 
        );
        return res.data;
    };

    const getPublicAllMeasureRecords = async () => {
        const res = await axios.get(
            `${apiUrl}/public/measure-record/course-schema/${uid}`,
            0, 
                {"bypassAuthCheck":true}
        );
        return res.data;
    };

    const getPublicRenderSelection = async (): Promise<any> => {  
        const payload = {
            "id":0,
            "account_id":0,
            "courseSchemaId":0,
            "visibleLayers":[],
            "visibleLayersKeys":null,
            "visibleRecords":[],
            "measureRecords":false,
            "mosaic":"",
            "mapStyle":"",
            "threeD":false,
            "hillshade":false,
            "permanentLayers":null
        };

        return new Promise(function(resolve, reject) {
            resolve(payload);
          });
    };

    const getPublicDefaultStyle = async (
        mapStyle: string,
    ) => {
        const res = await axios.get(
            `${apiUrl}/public/mapbox/style/course/${uid}/${mapStyle}.json`,
            0, 
                {"bypassAuthCheck":true}
        );

        return res.data;
    };

    const getPublicGeoRecord = async (geoRecordId: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/public/geo-record/${uid}/${geoRecordId}`,
            0,
            {"bypassAuthCheck":true}
        );
        return res.data;
    };

    const getPublicGeoRecordPerimeter = async (id: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/public/geometry-perimeter/${uid}/${id}`,
            0,
            {"bypassAuthCheck":true}
        );
        return res.data;
    };
    
    const getPublicAllIconFiles = async () => {
        const res = await axios.get(
            `${apiUrl}/public/geo-record-category/all/icons/${uid}`,
            0, {"bypassAuthCheck":true}
        );
        return res.data;
        // const payload = [];
        // return new Promise(function(resolve, reject) {
        //     resolve(payload);
        //   });
    };

    const getPublicMapboxLayerTree = async () => {
        const res = await axios.get(
            `${apiUrl}/public/mapbox/layer/tree/${uid}`,
            0, 
                {"bypassAuthCheck":true}
        );

        return res.data;
    };

    const getPublicAllMosaics = async () => {
        const res = await axios.get(
            `${apiUrl}/public/mapbox/mosaic/course/${uid}`,
            0, 
                {"bypassAuthCheck":true}
        );

        return res.data;
    };

    const getPublicAllCourseCoords = async () => {
        const res = await axios.get(
            `${apiUrl}/public/mapbox/course/coordinates/${uid}`,
            0, 
                {"bypassAuthCheck":true}
        );

        return res.data;
    };

     const fetchPublicCustomLayerData = async (): Promise<any> => {
        const payload = [];
        return new Promise(function(resolve, reject) {
            resolve(payload);
          });
    };

    return {
        getPublicGeoRecord,
        getPublicGeoRecordPerimeter,
        getPublicCourseSchema,
        getPublicAllGeoRecordsAsTree,
        getPublicCourseExtent,
        getPublicDefaultStyle,
        getPublicRenderSelection,
        getPublicAllMeasureRecords,
        getPublicAllIconFiles,
        getPublicMapboxLayerTree,
        getPublicAllMosaics,
        getPublicAllCourseCoords,
        fetchPublicCustomLayerData,
        createPublicLink,
    }

}